import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const r=t("denmark",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="#C60C30" />
            <path
                d="M8.88889 4.5H6.08187V11.0497H0V13.8567H6.08187V20.5H8.88889V13.8567H24V11.0497H8.88889V4.5Z"
                fill="white" />
        </svg>
    `),e=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40017"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40017)">
            <g clip-path="url(#clip0_4915_40017)">
                <path
                    d="M-5.96484 0.492188H30.0352V24.4922H-5.96484V0.492188Z"
                    fill="#C60C30" />
                <path
                    d="M7.36849 0.492188H3.15796V10.3167H-5.96484V14.5273H3.15796V24.4922H7.36849V14.5273H30.0352V10.3167H7.36849V0.492188Z"
                    fill="white" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40017">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-5.96484 0.492188)" />
            </clipPath>
        </defs>
    </svg>
`,n=t("denmark_rounded",e),m=t("DKK",e);export{m as DKK,r as Denmark,n as DenmarkRounded};
